import {
  DEFAULT_ENVIRONMENT,
  getEnvironmentPreset,
  type EnvironmentPreset,
} from "./environmentPresets";

export function connectEnvironmentPanel(onSelect: (preset: EnvironmentPreset) => void): void {
  const panel = document.querySelector<HTMLElement>("#environment-panel");
  const description = document.querySelector<HTMLElement>("#environment-description");
  if (!panel || !description) throw new Error("Missing required environment panel elements.");

  const buttons = [...panel.querySelectorAll<HTMLButtonElement>("[data-environment]")];
  connectAccordion(panel);
  for (const button of buttons) {
    button.addEventListener("click", () => {
      const preset = getEnvironmentPreset(button.dataset.environment ?? "");
      if (!preset) return;
      selectButton(buttons, button);
      description.textContent = preset.description;
      onSelect(preset);
    });
  }

  description.textContent = DEFAULT_ENVIRONMENT.description;
  panel.hidden = false;
}

function connectAccordion(panel: HTMLElement): void {
  const sections = [...panel.querySelectorAll<HTMLDetailsElement>(".panel-section")];
  for (const section of sections) {
    section.addEventListener("toggle", () => {
      if (!section.open) return;
      for (const other of sections) {
        if (other !== section) other.open = false;
      }
    });
  }
}

function selectButton(buttons: HTMLButtonElement[], selected: HTMLButtonElement): void {
  for (const button of buttons) {
    const isSelected = button === selected;
    button.setAttribute("aria-pressed", String(isSelected));
  }
}
